export interface ReportItem {
    name: string;
    src: string;
}

export interface ReportCategory {
    title: string;
    items: ReportItem[];
}

/**
 * 每年上載報告：在對應分類的 items 最上面加一行 { name, src }。
 * src 用已上載到學校網站的 PDF 網址。
 */
export const reportData: Record<string, ReportCategory> = {
    school_report: {
        title: "校務報告",
        items: [
            { name: "23-24年度校務報告", src: "https://www.pkps.edu.hk/pdf/2024-2025/report/2/23-24.pdf" },
            { name: "24-25年度校務報告", src: "https://www.pkps.edu.hk/pdf/report/school_report/2425.pdf" },
            { name: "25-26年度校務報告", src: "https://www.pkps.edu.hk/apps/meeting/pdf/2627-1st/1.pdf" }
        ],
    },
    anniversary_plan: {
        title: "學校周年計劃",
        items: [
            { name: "24-25年度周年計劃", src: "https://www.pkps.edu.hk/pdf/2024-2025/report/4/24-25.pdf" },
            { name: "25-26年度周年計劃", src: "https://www.pkps.edu.hk/pdf/report/anniversary/2526.pdf" },
            { name: "26-27年度周年計劃", src: "https://www.pkps.edu.hk/apps/meeting/pdf/2627-1st/2.pdf" },
        ],
    },
    all_round: {
        title: "全方位學習及姊妹學校津貼",
        items: [

            { name: "25-26全方位學習及姊妹學校津貼運用計劃", src: "https://www.pkps.edu.hk/pdf/report/all_round/2526plan.pdf" },
            { name: "25-26全方位學習津貼報告", src: "https://www.pkps.edu.hk/apps/meeting/pdf/2627-1st/7.pdf" },
            { name: "25-26姊妹學校交流計劃報告", src: "https://www.pkps.edu.hk/apps/meeting/pdf/2627-1st/8.pdf" },
            { name: "26-27全方位學習及姊妹學校津貼運用計劃", src: "https://www.pkps.edu.hk/apps/meeting/pdf/2627-1st/9.pdf" },
        ],
    },
    sister_school: {
        title: "姊妹學校交流計劃",
        items: [
            { name: "2023-2024姊妹學校交流計劃報告", src: "http://www.pkps.edu.hk/pdf/2024-2025/report/6/23-24report.pdf" },
            { name: "2024-2025姊妹學校交流計劃", src: "http://www.pkps.edu.hk/pdf/2024-2025/report/6/24-25plan.pdf" },
        ],
    },
    support_report: {
        title: "校本課後學習及支援計劃",
        items: [
            { name: "2025-2026校本課後學習及支援計劃活動報告", src: "https://www.pkps.edu.hk/apps/meeting/pdf/2627-1st/18.pdf" },
            { name: "2025-2026校本課後學習及支援計劃", src: "https://www.pkps.edu.hk/pdf/2025-2026/report/2526support_plan.pdf" },
            { name: "2024-2025校本課後學習及支援計劃報告", src: "https://www.pkps.edu.hk/pdf/2025-2026/report/2425support_report.pdf" },
            { name: "2024-2025校本課後學習及支援計劃", src: "https://www.pkps.edu.hk/pdf/2024-2025/report/8/24-25plan.pdf" },
        ],
    },
    development_subsidy: {
        title: "學校發展津貼",
        items: [
            { name: "學校發展津貼(2024-2025計劃)", src: "/pdf/學校發展津貼(2024-2025計劃).pdf" },
            { name: "學校發展津貼(2025-2026計劃)", src: "/pdf/學校發展津貼(2025-2026計劃).pdf" },
        ],
    },
    reading_report: {
        title: "運用推廣閱讀津貼計劃",
        items: [
            { name: "2026-2027 運用推廣閱讀津貼_計劃書", src: "https://www.pkps.edu.hk/apps/meeting/pdf/2627-1st/14.pdf" },
            { name: "2025-2026 運用推廣閱讀津貼_運用報告", src: "https://www.pkps.edu.hk/apps/meeting/pdf/2627-1st/13.pdf" },
            { name: "2025-2026 運用推廣閱讀津貼_計劃書", src: "http://www.pkps.edu.hk/pdf/2025-2026/report/2526reading_plan.pdf" },
            { name: "2024-2025 運用推廣閱讀津貼_運用報告", src: "http://www.pkps.edu.hk/pdf/2025-2026/report/2425reading_report.pdf" },
        ],
    },
    activity_support: {
        title: "學生活動支援津貼",
        items: [
            { name: "2026-2027優化校本學習活動支援津貼運用計劃", src: "https://www.pkps.edu.hk/apps/meeting/pdf/2627-1st/17.pdf" },
            { name: "2025-2026學生活動支援津貼運用報告", src: "https://www.pkps.edu.hk/apps/meeting/pdf/2627-1st/16.pdf" },
            { name: "2024-2025學生活動支援津貼運用報告", src: "https://www.pkps.edu.hk/pdf/2025-2026/report/9/24-25report.pdf" },
        ],
    },
    board_training: {
        title: "校董周年培訓計劃",
        items: [
            { name: "2026-2027校監和校董周年培訓計劃", src: "https://www.pkps.edu.hk/apps/meeting/pdf/2627-1st/plan26-27.pdf" },
            { name: "2025-2026校董周年培訓計劃", src: "https://www.pkps.edu.hk/pdf/report/10/25-26plan.pdf" },
        ],
    },
    other_report: {
        title: "各類一次性津貼計劃",
        items: [
            { name: "支援開設小學科學科一筆過津貼計劃(2026-2027)", src: "https://www.pkps.edu.hk/apps/meeting/pdf/2627-1st/10.pdf" },
            { name: "支援學校推動校園體育氛圍及MVP60津貼計劃(2026-2027)", src: "https://www.pkps.edu.hk/apps/meeting/pdf/2627-1st/11.pdf" },
            { name: "推廣中華文化體驗活動一筆過津貼計劃(2026-2027)", src: "https://www.pkps.edu.hk/apps/meeting/pdf/2627-1st/12.pdf" },
            { name: "家長教育津貼運用報告(2025-2026)", src: "https://www.pkps.edu.hk/apps/meeting/pdf/2627-1st/15.pdf" },
            { name: "支援開設小學科學科一筆過津貼計劃(2025-2026)", src: "https://www.pkps.edu.hk/pdf/report/other_report/science2526.pdf" },
            { name: "支援學校推動校園體育氛圍津貼計劃(2025-2026)", src: "https://www.pkps.edu.hk/pdf/report/other_report/enhance2526.pdf" },
            { name: "家長教育津貼運用計劃(2025-2026)", src: "https://www.pkps.edu.hk/pdf/2025-2026/report/2526par_plan.pdf" },
            { name: "家長教育津貼運用報告(2024-2025)", src: "https://www.pkps.edu.hk/pdf/2025-2026/report/2425par_report.pdf" },
            { name: "推廣中華文化體驗活動一筆過津貼計劃(2025-2026)", src: "https://www.pkps.edu.hk/pdf/report/other_report/culture2526.pdf" },
        ],
    },
};
